import React from 'react';
import { useRouter } from '@ers/hooks';
import Maybe from 'react-maybe';
import PropTypes from 'prop-types';

import { Typo } from '@ers/ui';
import { FileHelper } from '@ers/helpers/';
import { getApplicationFile } from '@ers/pages/home/Home.selectors';
import useLazyOpen from '@ers/lazyOpen';
import { Spinner } from '@ers/ui/';
import { Field, FileImage } from '.';

const FileViewHooked = ({ file }) => {
    const { match: { params: { applicationId } } } = useRouter();
    const { open: openFile, isLoading } = useLazyOpen('File', 'Home', [applicationId, file.fileId], getApplicationFile, FileHelper.openFileInNewWindow);
    const fileviewProps = {};
    if (!isLoading) {
        fileviewProps.onClick = openFile;
        fileviewProps.className = 'file-view';
    } else {
        fileviewProps.className = 'file-view file-view--loading';
    }
    return <FileView file={file} fileviewProps={fileviewProps} isLoading={isLoading} />;
};

FileViewHooked.propTypes = FileImage.propTypes;
FileViewHooked.defaultProps = FileImage.defaultProps;

export default FileViewHooked;
export const FileView = ({ file, fileviewProps, isLoading }) => (
    <Maybe
        of={file.fileId}
        either={(
            <Field>
                <div {...fileviewProps}>
                    {isLoading
                        ? (
                            <i className="icon icon--file">
                                <Spinner />
                            </i>
                        )
                        : <FileImage file={file} />}
                    <div className="file-view__data">
                        <Typo.Body>{file.name}</Typo.Body>
                        <Typo.Caption>{FileHelper.sizeToDisplay(file.size)}</Typo.Caption>
                    </div>
                </div>
            </Field>
        )}
        orElse={null}
    />
);

FileView.propTypes = { isLoading: PropTypes.bool,
    fileviewProps: PropTypes.object,
    ...FileImage.propTypes };
FileView.defaultProps = { isLoading: false,
    fileviewProps: { className: 'file-view' },
    ...FileImage.defaultProps };

